import {makeAutoObservable} from 'mobx';
import ClientService from '../ClientService';
import DeviceService from '../DeviceService';
import config from '../../config';
import {autoSave} from "../autoSave";
import {User} from "./UserStore";
import React from "react";
import {PopperPlacementType} from "@mui/material";
import {Message} from './MessageStore';

interface UserInfoView {
    selectedUser: User
    userAnchorEl: React.MutableRefObject<HTMLHtmlElement>
    userInfoPlacement: PopperPlacementType
}

export class UiStore {
    appKey: string = "shadow";
    isMobile: boolean;
    orientation: string;
    color: string | null;
    sortOrder: string;
    themeManagerEnabled: boolean;
    appManagerEnabled: boolean;
    themeManagerVisible: boolean;
    userListVisible: boolean;
    settingsVisible: boolean;
    messagesVisible: boolean;
    managerFocused: boolean;
    messagesWidth: number | null;
    sliderOpen: boolean;
    appInfoVisible: boolean;
    platform: string;
    roomListVisible: boolean;

    userInfoView: UserInfoView | null = null;
    userInfoVisible: boolean = false;
    editedMessage: Message | null = null;
    debugModeEnabled: boolean = false;
    reactionPanelMessage: Message | null = null;

    constructor() {
        this.isMobile = ClientService.isMobile();
        this.orientation = DeviceService.getOrientation();
        this.color = null;
        this.sortOrder = "asc";
        this.themeManagerEnabled = true
        this.appManagerEnabled = false;
        this.themeManagerVisible = false;
        this.userListVisible = false;
        this.roomListVisible = false;
        this.settingsVisible = false;
        this.messagesVisible = true;
        this.managerFocused = false;
        this.messagesWidth = null;
        this.sliderOpen = false;
        this.appInfoVisible = true;
        this.platform = navigator.platform.indexOf('Win') > -1 ? "windows" : "other";

        makeAutoObservable(this);

        autoSave(this, "appManagerEnabled", `${this.appKey}-appManagerEnabled`);
        autoSave(this, "debugModeEnabled", `${this.appKey}-debugModeEnabled`);

        if (!(this.themeManagerEnabled && this.isMobile)) {
            autoSave(this, "themeManagerEnabled", `${this.appKey}-themeManagerEnabled`);
        }

        autoSave(this, "sliderOpen", `${this.appKey}-sliderOpen`);
        autoSave(this, "appInfoVisible", `${this.appKey}-appInfoVisible`);
        autoSave(this, "sortOrder", `${this.appKey}sortOrder`);

        const mqlQuery = '(max-width: 750px)';
        const mql = window.matchMedia(mqlQuery);

        mql.addEventListener("change", () => {
            this.isMobile = ClientService.isMobile()
        });

        const onResize = () => {
            this.orientation = DeviceService.getOrientation();
        }

        if (this.isMobile) {
            if (!screen.orientation || !('onchange' in screen.orientation)) {
                window.addEventListener('resize', onResize, false);
            } else {

                screen.orientation.onchange = () => {
                    const orientation = screen.orientation.type;

                    if (orientation.startsWith("landscape")) {
                        this.orientation = DeviceService.getOrientation();
                    } else {
                        this.orientation = DeviceService.getOrientation();
                    }

                }
            }

        } else {
            window.addEventListener('resize', onResize, false);
        }
    }

    loadImage(name: string): Promise<HTMLImageElement> {
        const url = `${config.apiUrl}/static/backgrounds/${name}`;
        let img: HTMLImageElement = document.createElement("img");
        img.crossOrigin = 'Anonymous';
        img.src = url;

        return new Promise<HTMLImageElement>((resolve) => {
            img.addEventListener('load', (event) => {
                resolve(img)
            });
        });
    }

    isLandScape(): boolean {
        return this.orientation === 'landscape';
    }
}

const uiStore = new UiStore();
export default uiStore;
